export default __webpack_public_path__ + "end-device.e1566e3b68b8783c4e03.svg";